import React, { useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import MarketMakerForm from "./MarketMakerForm";
import MarketMakerStatus from "./MarketMakerStatus";

const MarketMaker = () => {
  const [showForm, setShowForm] = useState(false);

  const handleToggleView = () => {
    setShowForm(!showForm);
  };

  const handleFormSuccess = () => {
    // After successful market maker creation, go back to list
    setShowForm(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Market Maker"
            breadcrumbItem={showForm ? "Create Market Maker" : "Market Maker Management"}
          />

          <Row className="mb-3">
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="page-title mb-0">
                  {showForm ? "Create New Market Maker" : "Market Maker Sessions"}
                </h4>
                <Button
                  color={showForm ? "secondary" : "primary"}
                  onClick={handleToggleView}
                >
                  {showForm ? "Back to List" : "Create Market Maker"}
                </Button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              {showForm ? (
                <MarketMakerForm onSuccess={handleFormSuccess} />
              ) : (
                <MarketMakerStatus />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MarketMaker;
